/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */
//Standard libraries
import { CircularProgress } from "@material-ui/core";
import { head } from "lodash-es";
import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { LoginModal } from "../../../components/header";
import { useSelector } from "react-redux";
//UI
import {
  StyledGrid,
  StyledButton,
  StyledTable,
  StyledTableIcons,
  StyledB2BDetailPanel,
} from "../../elements";
import { useProductValue } from "../../../_foundation/context/product-context"; /*"../context/product-context";*/
import { loginStatusSelector } from "../../../redux/selectors/user";

// Context
import ModalContext from "../../../_foundation/context/ModalContext";
import { ProductoAgotado } from "../../elements/ProductoAgotado/producto-agotado";

type SkuListWidgetProps = {
  productDetails: any;
  [extraProps: string]: any;
};

/**
 * B2B SKU table content display component
 * @description Displays product information ,prize ,quantity ,detailed info for each sku.
 * ` @prop { any } productDetails` The product details object has following properties:
 * ` @property { any } productPartNumber (required)` The productPartNumber of product in string.
 * ` @property { object } translation (required)`  A object which holds multiple string values for transation purpose .
 * ` @property { any[] } tableHeaderData (required)` contains State data for header part of table.
 * ` @property { any[] } tableBodyData (required)` contains State data for table body .
 * ` @property { any[] } tableDetailHeaderData (required)` contains state data for table details header .
 * ` @property { any } loginNotRequired (required)` flag indicate whether login is required or not.
 * ` @property { Function } addToCart (required)`function for Adding the selected product and its quantities to the shopping cart
 * ` @property { boolean } disabledButtonFlag (required)` flag for disabled button.
 * ` @property { string } SIGNIN (required)` Sign In is string for path .
 */
export const SkuListWidget: React.FC<SkuListWidgetProps> = ({
  productDetails,
  isElectronico,
  ...props
}) => {
  const productPartNumber = productDetails.productPartNumber;
  const translation = productDetails.translation;
  const tableHeaderData = productDetails.tableHeaderData;
  const tableBodyData = productDetails.tableBodyData;
  const tableDetailHeaderData = productDetails.tableDetailHeaderData;
  const loginNotRequired = productDetails.loginNotRequired;
  const addToCart = productDetails.addToCart;
  const disabledButtonFlag = productDetails.disabledButtonFlag;
  const SIGNIN = productDetails.SIGNIN;
  const { skuAndQuantities } = useProductValue();
  const loginStatus = useSelector(loginStatusSelector);

  const [openModalLogin, setOpenModalLogin] = useState(false);
  const [openModalReg, setOpenModalReg] = useState(false);
  const [loading, setLoading] = useState(false);

  const newheadcolumns = [
    { field: "Talla", title: "Talla", align: "center", width: "90px" },
    { field: "sku", title: "Código de artículo", align: "center" },
    {
      field: "quantity",
      title: translation.productDetailQuantity,
      align: "center",
      width: "120px",
    },
    {
      field: "online_availability",
      title: translation.productDetailOnline_Availability,
      align: "center",
      width: "110px",
    },
  ];
  // const newheadcolumns = productDetails.tableHeaderData.map(header => {
  //   header.align = 'center'
  //   return header
  // })
  const {
    setCounterClicks,
    handleCounterClicks,
    isOpen,
    setIsOpen,
    counterClicks,
    setCloseSesion,
    closeSesion,
  } = useContext(ModalContext);

  const dataBody = tableBodyData;
  // const dataBody = tableBodyData.slice(0, 5);
  const handleOpenModalLogin = () => {
    setOpenModalLogin(true);
    setOpenModalReg(false);
  };

  const handleSwitchModalLogin = () => {
    setOpenModalReg(!openModalReg);
  };

  const handleCloseModalLogin = () => setOpenModalLogin(false);

  async function handleAddToCart() {
    setIsOpen(false);
    handleCounterClicks();
    //check if product is available with getAvailability service
    setLoading(true);
    const resultado = await addToCart(isElectronico);
    setLoading(false);
  }

  dataBody.sort((a, b) => (a.sku > b.sku ? 1 : -1));
  const newDataBody = dataBody.filter((e) => e.Talla !== undefined);

  useEffect(() => {
    if (window.productsQuantities != undefined && loginNotRequired == true) {
      if (Object.keys(window.productsQuantities).length !== 0) {
        handleAddToCart();
      }
    }
  }, [loginStatus, loginNotRequired]);

  return tableHeaderData && tableHeaderData.length > 0 ? (
    <>
      {isElectronico === false &&
        <StyledTable
          /*style={{ marginTop: "-25px" }}*/
          icons={StyledTableIcons}
          columns={newDataBody?.length > 0 ? newheadcolumns : []}
          data={newDataBody}
          disabled={true}
          title=""
          /*detailPanel={
            tableDetailHeaderData.length > 0
              ? [
                  {
                    tooltip: translation.productDetailshowAttributes,
                    render: (rowData: any) => {
                      let detailData: any[] = [];
                      let data: any = {};
                      for (const d of tableDetailHeaderData) {
                        data[d.field] = rowData[d.field];
                      }
                      detailData.push(data);
                      return (
                        <StyledB2BDetailPanel>
                          <StyledTable
                            columns={tableDetailHeaderData}
                            data={detailData}
                            icons={StyledTableIcons}
                            title=""
                            options={{
                              search: false,
                              minBodyHeight: "0px",
                              paging: false,
                              toolbar: false,
                              padding: "dense",
                              rowStyle: {
                                fontSize: "10px",
                              },
                              headerStyle: {
                                paddingBottom: "4px",
                              },
                            }}
                          />
                        </StyledB2BDetailPanel>
                      );
                    },
                  },
                ]
              : null
          }*/
          options={{
            search: false,
            paging: false,
            toolbar: false,
            sorting: false,
            draggable: false,
            headerStyle: {
              verticalAlign: "top",
              padding: "0px",
            },
            bodyStyle: {
              padding: "0px",
            },
          }}
          localization={{
            body: {
              emptyDataSourceMessage:
              <ProductoAgotado/>,
            },
          }}
        />
      }
      <div className = {"add2cart-pdp-container"}>
        {tableBodyData.length > 0 ? (
          loginNotRequired ? (
            <StyledButton
              color="primary"
              size="small"
              className="product-add-to-cart custom-add-to-cart"
              id={`product_add_to_cart_${productPartNumber}`}
              onClick={handleAddToCart}
              style={{ float: "none", color: "#ffffff" }}>
              {loading ? (
                <CircularProgress size={24} style={{ color: "#ffffff" }} />
              ) : (
                translation.productDetailaddToCurrentOrder
              )}
            </StyledButton>
          ) : (
            <StyledButton
              color="primary"
              className="product-add-to-cart custom-add-to-cart"
              onClick={handleOpenModalLogin}
              style={{ float: "none", width: "60% !important" }}>
              {translation.productDetailSignIn}
            </StyledButton>
          )
        ) : 
        (isElectronico && 
        <div style={{marginTop:"15px"}}>
          <ProductoAgotado/>
        </div>)}
      </div>

      <LoginModal
        openModalLogin={openModalLogin}
        handleCloseModalLogin={handleCloseModalLogin}
        openModalReg={openModalReg}
        handleSwitchModalLogin={handleSwitchModalLogin}
      />
    </>
  ) : null;
};
